import { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '@/lib/supabase'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setSuccess(false)
    setLoading(true)

    const baseUrl = window.location.origin.includes('localhost')
      ? 'http://localhost:3000'
      : 'https://insideaccess.live'

    const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: `${baseUrl}/set-password`,
    })

    if (error) {
      setError(error.message)
      setLoading(false)
    } else {
      setSuccess(true)
      setLoading(false)
    }
  }

  if (success) {
    return (
      <div className="max-w-md mx-auto">
        <h1 className="text-2xl font-bold mb-6">Please check your email</h1>
        <p className="text-text-primary mb-4">
          If the email address you entered (<strong>{email}</strong>) is linked to an account with us, we’ll send you a message shortly with a secure link to reset your password.
        </p>
        <p className="text-text-primary mb-4">
          Didn’t see it? Please check your spam or junk folder — and feel free to try again if needed.
        </p>
        <Link to="/login" className="text-text-link underline font-semibold">
          Back to login
        </Link>
      </div>
    )
  }

  return (
    <div className="max-w-md mx-auto">
      <h1 className="text-2xl font-bold mb-6">Forgot password</h1>
      <p className="text-text-primary mb-4">
        Enter your email address and we’ll send you a link to reset your password.
      </p>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block mb-2 font-semibold">
            Email
            <span className="text-color-error" aria-label="required"> *</span>
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            aria-required="true"
            className="w-full"
            autoComplete="email"
          />
        </div>

        {error && (
          <div role="alert" className="text-color-error">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-bg-interactive text-text-inverse hover:bg-bg-interactive-hover disabled:opacity-50"
        >
          {loading ? 'Sending…' : 'Send reset link'}
        </button>
      </form>

      <p className="mt-4 text-base text-text-primary">
        <Link to="/login" className="text-text-link underline font-semibold">
          Back to login
        </Link>
      </p>
    </div>
  )
}
